<form [formGroup]="FeeForm">
    <div class="card-body">
            <div class="col-sm-12 text-center">
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/images/receipt.png" class="mh-45px pb-2">
                    <div class="ml-2">
                        <h2 class="main-content-label mb-1 ml-2"><b>Registration Fee Process
                            </b>
                        </h2>
                    </div>
                </div>
            </div>
            <div class="row clearfix">
                <div class="table-responsive table-container mt-4 ">
                    <table id="datatable" class="table table-bordered text-nowrap">
                        <thead>
                            <tr>
                                <th width="20%" class="f600">Head</th>
                                <th width="20%" class="f600">Head Name</th>
                                <!-- <th width="20%" class="f600">Fee Type</th> -->
                                <th width="20%" class="f600">Fee Amount</th>
                            </tr>
                        </thead>

                        <tbody id="table_data" formArrayName="feeHeadArray">
                             <tr *ngFor="let fee of getfeeHeadArrayControls(); let i = index; let last = last "
                                [formGroupName]="i"> 
                                 <td>
                                    <input class="form-control  input-sm" readonly formControlName="FeeHead"
                                        maxlength="8" id="addone">
                                </td>
                                <td>
                                    <input class="form-control input-sm" formControlName="HeadName" readonly style="display: inline-block; width: 12rem;">
                                </td>
                                <!-- <td>
                                <span style="display: inline-block; margin-right: 1rem;">{{ fee.get('FeeType')?.value == 'RF' ? 'Regular Fee' : fee.get('FeeType')?.value == 'LF' ? 'Late Fee' : '' }}</span>
                            </td> -->
                                <td *ngIf="Currency == 'INR' ">
                                    <span class="currency-symbolTd">&#8377; </span><input class="form-control mrrr input-sm" formControlName="FeeAmt" readonly>
                                </td>
                                
                                <td *ngIf="Currency == 'USD' ">
                                    <span class="currency-symbolTd">&#8377;</span><input class="form-control mrrr input-sm" formControlName="FeeAmt" readonly>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-12 row">
                    <div class="col-sm-3" *ngIf="feeModeShow">
                        <!-- <h6 *ngIf="FeeLevel == 'SW' && hasMultipliedFee">Note: The exam fee shown above is calculated as:<br>
                        (Exam Fee per subject) × (Number of Subjects) = {{ExamFee}} x {{filteredElements.length}}</h6> -->
                    </div>
                    <div  *ngIf="Currency == 'INR' " class="col-sm-6 mrg mrg1">
                        <span class="Text">Total Amount :</span><span class="currency-symbol">&#8377;{{totalAmount}}
                        </span>
                        <br>

                        <!-- <span class="Text mr3">Amount To Be Paid:<span class="currency-symbolTd">&#8377;</span>
                        </span> -->
                        
                        <!-- <mat-form-field *ngIf="submitButton "  appearance="outline" class="example-full-width col-sm-3">
                            <input onkeydown="return (event.keyCode!=13);" maxlength="8" class="color ff1" matInput
                                formControlName="TotalPaidAmount" (keyup)="onInputChange($event)">
                            
                        </mat-form-field> -->
                        <mat-error class="margin_tp ml1" *ngIf="showEqualMessage">
                           Please Pay Full Amount.
                        </mat-error>
                        
                        <mat-error class="margin_tp" *ngIf="shouldShowErrorMessage">
                                Amount Should Not Be Greater Than Remainig Amount.
                            </mat-error>
                            <mat-error class="margin_tp err"
                                *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.required">
                                This Field Is Mandatory.
                            </mat-error>
                            <mat-error class="margin_tp err"
                                *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.pattern">
                                Please Enter Valid Data.
                            </mat-error>
                    </div>

                    <div *ngIf="Currency == 'USD'" class="col-sm-6 mrg mrg1">
                        <span class="Text">Total Amount :</span><span class="currency-symbol">&#8377;{{totalAmount}}
                        </span>
                        <br>

                        <span class="Text mr3">Amount To Be Paid:<span class="currency-symbolTd">$</span>
                        </span>
                        
                        <mat-form-field *ngIf="submitButton "   appearance="outline" class="example-full-width col-sm-3">
                            <input *ngIf="submitButton " onkeydown="return (event.keyCode!=13);" maxlength="8" class="color ff1" matInput
                                formControlName="TotalPaidAmount" (keyup)="onInputChange($event)">
                            
                        </mat-form-field>
                        
                        <mat-error class="margin_tp ml1" *ngIf="zeroError">
                            Enter Valid Amount.
                        </mat-error>
                        <mat-error class="margin_tp ml1" *ngIf="showEqualMessage">
                           Please Pay Full Amount.
                        </mat-error>
                        
                        <mat-error class="margin_tp" *ngIf="shouldShowErrorMessage">
                                Amount Should Not Be Greater Than Remainig Amount.
                            </mat-error>
                            <mat-error class="margin_tp err"
                                *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.required">
                                This Field Is Mandatory.
                            </mat-error>
                            <mat-error class="margin_tp err"
                                *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.pattern">
                                Please Enter Valid Data.
                            </mat-error>
                        
                    </div>
                </div>
                <!-- <div class="col-sm-12"   *ngIf="Currency == 'INR' ">
                    <span class="Text mrg5">Total Remaining Amount :</span><span
                        class="currency-symbol Textmrg1">&#8377;{{remainAmt}}</span>

                </div>
                <div class="col-sm-12"   *ngIf="Currency == 'USD'">
                    <span class="Text mrg5">Total Remaining Amount :</span><span
                        class="currency-symbol Textmrg1">$ {{remainAmt}}</span>

                </div> -->
                
                <div class="col-sm-12">
                    <button type="button" *ngIf="payHistoryBtn"
                    class="btn fr sz btn-primary btn-icon-text floatright mt-1 fr" (click)="openHistoryPopup()">
                    <span style="display: contents; align-items: center;">
                        <img width="22vh" src="../../assets/images/history.gif" style="margin-right: 5px;">
                        Payment History
                    </span>
                </button>
                <!-- [disabled]="updateBtn" *ngIf="submitButton "-->
                    <button type="button" *ngIf="submitButton "    
                        class="btn fr sz btn-primary btn-icon-text floatright mt-1 fr" (click)="submitFeeTemplet()">
                        <span style="display: contents; align-items: center;">
                            <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;">
                            Save
                        </span>
                    </button>
                    <button type="button" class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1 fr"
                        (click)="close()">
                        <span style="display: contents; align-items: center;">
                            <img width="20vh" src="../../assets/images/letter-x.gif" style="margin-right: 7px;">
                            Close
                        </span>
                    </button>
                </div>
            </div>
    </div>
</form>